import React from 'react';

interface AllowedModalBodyProps {
  padding?: string;
  children?: React.ReactNode;
}

/** @deprecated - prefer `design-system/Dialog` (DialogContent) */
export const ModalBody: React.FC<AllowedModalBodyProps> = ({ padding = '32px', children }) => {
  return (
    <div>
      {children}
      <style jsx>{`
        div {
          padding: ${padding};
        }
      `}</style>
    </div>
  );
};
